import React from "react";
import "../../../App.css";
import Moment from "moment/moment";
import styles from "../../../pages/taxDeclaration/listData/ListData.module.css";
import Tafgeet from "tafgeetjs";
function RealEstateTaxPaymentReceipt(props) {
  return (
    <>
      <div className={`${styles["box-header"]}`}>
        <h3
          className={`${styles["box-title"]} mb-0 mx-5`}
          Style="color:#005da8"
        >
          إيصال سداد الضريبة العقارية
        </h3>
      </div>
      <div className="card card-1 p-lg-3 p-2 m-2 m-lg-5">
        <div className="row">
          <div className="col-md-4">
            <div className="content-text">
              <p className="fw-bold">
                <span>نوع الخدمة : </span>
                <span> {props.data.service_type}
                </span>
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="content-text">
              <p className="fw-bold">
                <span>رقم المدفوعة : </span>
                <span>
                  {props.data.payment ? props.data.paymentRequestNo : ""}
                </span>
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="content-text">
              <p className="fw-bold">
                <span>{props.data.payment_method}</span>
                <span></span>
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="content-text">
              <p className="fw-bold d-flex align-items-start justify-content-start gap-2">
                <span>مصدر المديونية : </span>
                <span>
                  <span>{props.data.source_of_debt_type}</span>
                  <span className="d-block">
                    منطقة {props.data.payment ? props.data.payment.gov : ""}
                  </span>
                  <span className="d-block">
                    مأمورية{" "}
                    {props.data.payment ? props.data.payment.district : ""}
                  </span>
                </span>
              </p>
            </div>
          </div>
          <div className="col-md-8">
            <div className="content-text">
              <p className="fw-bold">
                <span>الكود المؤسسى : </span>
                <span>
                  {props.data.payment ? props.data.payment.serial : ""}
                </span>
              </p>
              <p className="fw-bold">
                <span>تاريخ / وقت سداد المديونية : </span>
                <span>
                  {props.data.payment
                    ? Moment(props.data.created_at).format(" D/M/y h:m a")
                    : ""}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <h2 className="mt-4 mx-lg-5 fw-bold">بيانات المديونية :</h2>
      <div className="card card-2 p-lg-3 p-2 m-2 m-lg-5">
        <div className="content-text">
          <p className="fw-bold">
            <span> المبلغ المسدد : </span>
            <span>
              {props.data.payment ? props.data.settlementAccountAmount : ""}
            </span>
          </p>
        </div>
        <div className="content-text">
          <p className="fw-bold">
            <span>كود حساب الوحدة : </span>
            <span>{props.data.payment ? props.data.payment.acc_key : ""}</span>
          </p>
        </div>
        <div className="content-text">
          <p className="fw-bold">
            <span>اسم الشاغل : </span>
            <span>
              {props.data.payment ? props.data.payment.occupant_name : ""}
            </span>
          </p>
        </div>
        <div className="content-text">
          <p className="fw-bold">
            <span>اسم المسدد : </span>
            <span>{props.data.payment ? props.data.payer_name : ""}</span>
          </p>
        </div>
        <div className="content-text">
          <p className="fw-bold">
            <span>عنوان الوحدة : </span>
            <span>
              {props.data.payment && props.data.payment.gov ? `محافظة ` : ""}
              {props.data.payment && props.data.payment.gov
                ? `${props.data.payment.gov} - `
                : ""}
              {props.data.payment && props.data.payment.district
                ? `${props.data.payment.district} - `
                : ""}
              {props.data.payment && props.data.payment.village
                ? `${props.data.payment.village}  ${
                    props.data.payment.place ? "- " : "- شارع "
                  }`
                : ""}
              {props.data.payment && props.data.payment.place
                ? `${props.data.payment.place} - شارع `
                : ""}
              {props.data.payment && props.data.payment.street
                ? `${props.data.payment.street} - رقم العقار `
                : ""}
              {props.data.payment && props.data.payment.build
                ? `${props.data.payment.build} - الدور `
                : ""}
              {props.data.payment && props.data.payment.part
                ? `${props.data.payment.part} - رقم الوحدة `
                : ""}
              {props.data.payment && props.data.payment.unit
                ? props.data.payment.unit
                : ""}
            </span>
          </p>
        </div>
      </div>
      <h2 className="mt-4 mx-lg-5 fw-bold text-balck">المبالغ المسددة :</h2>
      <div className="card card-3 p-lg-3 p-2 m-2 m-lg-5">
        <div className="row">
          <div className="col-md-4">
            <div className="content-text">
              <p className="fw-bold">
                <span>المبلغ : </span>
                <span>
                  {props.data.payment ? props.data.settlementAccountAmount : ""}
                </span>
              </p>
            </div>
          </div>
          <div className="col-md-2">
            <div className="content-text">
              <p className="fw-bold">
                <span>العملة : </span>
                <span>
                  {props.data.currency}
                </span>
              </p>
            </div>
          </div>
          <div className="col-md-6">
            <div className="content-text">
              <p className="fw-bold">
                {/*<span>فقط : </span>*/}
                <span>
                  {props.data.payment
                    ? new Tafgeet(
                        props.data.settlementAccountAmount,
                        "EGP"
                      ).parse()
                    : ""}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default RealEstateTaxPaymentReceipt;
